<div class="flex flex-col w-full min-w-0 sm:absolute sm:inset-0 sm:overflow-hidden">
    <mat-drawer-container class="flex-auto sm:h-full">
        <!-- Drawer -->
        <mat-drawer class="sm:w-96 dark:bg-gray-900" [autoFocus]="false" [mode]="drawerMode" [opened]="drawerOpened" #drawer>
            <!-- Header -->
            <div class="flex items-center justify-between m-7 mt-6 ml-8 mr-6 sm:my-10">
                <!-- Title -->
                <span>
                    <div class="text-4xl font-extrabold tracking-tight leading-none">
                        {{ 'label_document_center' | translate }}
                    </div>
                </span>
                <!-- Close button -->
                <div class="lg:hidden">
                    <button mat-icon-button (click)="drawer.close()">
                        <mat-icon [matTooltip]="'Fela yfirlit'" [svgIcon]="'heroicons_outline:minus'"></mat-icon>
                    </button>
                </div>
            </div>

            <!-- Panel links -->
            <div class="flex flex-col divide-y border-t border-b">
                @for (panel of panels; track trackByFn($index, panel)) {
                    <span>
                        <div
                            class="flex px-8 py-5 cursor-pointer"
                            [ngClass]="{
                                'hover:bg-gray-100 dark:hover:bg-hover': !selectedPanel || selectedPanel !== panel.id,
                                'bg-primary-50 dark:bg-hover': selectedPanel && selectedPanel === panel.id,
                            }"
                            (click)="goToPanel(panel.id, panel.component)"
                        >
                            @if (panel?.icon) {
                                <mat-icon
                                    [ngClass]="{
                                        'text-hint': !selectedPanel || selectedPanel !== panel.id,
                                        'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id,
                                    }"
                                    [svgIcon]="panel.icon"
                                ></mat-icon>
                            }
                            @if (panel?.fontAwesomeIcon) {
                                <i
                                    class="{{ panel.fontAwesomeIcon }} fa-lg mt-[11px]"
                                    [ngClass]="{
                                        'text-hint': !selectedPanel || selectedPanel !== panel.id,
                                        'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id,
                                    }"
                                ></i>
                            }
                            <div class="ml-3">
                                <div
                                    class="font-medium leading-6"
                                    [ngClass]="{
                                        'text-primary dark:text-primary-500': selectedPanel && selectedPanel === panel.id,
                                    }"
                                >
                                    {{ panel.title }}
                                </div>
                                <div class="mt-0.5 text-secondary">
                                    {{ panel.description }}
                                </div>
                            </div>
                        </div>
                    </span>
                }
            </div>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex flex-col">
            <div class="flex-auto">
                <div class="lg:hidden flex items-center px-6 pt-5 pb-6 md:p-6 md:pb-7 border-b bg-card dark:bg-transparent">
                    <!-- Drawer toggle -->
                    <button class="-ml-2" mat-icon-button (click)="drawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                    </button>
                    <!-- Panel title -->
                    <span>
                        <div class="ml-2 lg:ml-0 text-3xl font-bold tracking-tight leading-none">
                            {{ getPanelTitle(selectedPanel) }}
                        </div>
                        <div class="ml-2 lg:ml-0 font-medium text-secondary mt-[5px]">
                            {{ getPanelDescription(selectedPanel) }}
                        </div>
                    </span>
                </div>
                @if (showPanel) {
                    <div class="px-6 pt-9 pb-12 md:p-8 md:pb-12 lg:p-12">
                        @switch (selectedComponent) {
                            @case ('app-documents-add') {
                                <app-documents-add></app-documents-add>
                            }
                            @case ('app-documents-overview') {
                                <app-documents-overview></app-documents-overview>
                            }
                            @case ('documents-jobs') {
                                <documents-jobs></documents-jobs>
                            }
                        }
                    </div>
                }
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
